import { getScrollContainer, getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

function initializePathReveal() {
  window.tbPathRevealCleanup?.();
  const host = document.querySelector('tb-path-navigation[data-reveal="true"]:not([hidden])');
  if (!host) return;

  const marker = document.createElement('span');
  marker.className = 'tb-path__marker';
  marker.setAttribute('aria-hidden', 'true');
  host.before(marker);
  const header = document.getElementById('header-component');
  const details = host.querySelector('[data-path-history]');
  const controller = new AbortController();
  const { signal } = controller;
  let scrollTarget;
  let frame = 0;
  let visible = false;
  let lastTop = scrollTop();
  let directionTop = lastTop;
  let lastDirection = 0;

  function scrollTop() {
    const container = getScrollContainer();
    return Math.max(0, Math.min(container.scrollTop, container.scrollHeight - container.clientHeight));
  }

  function update() {
    frame = 0;
    const top = scrollTop();
    const delta = top - lastTop;
    const direction = Math.sign(delta);
    if (direction && direction !== lastDirection) directionTop = lastTop;
    if (direction) lastDirection = direction;
    if (direction && Math.abs(top - directionTop) >= 2) visible = direction < 0;
    lastTop = top;

    let offset = 0;
    if (header?.hasAttribute('sticky') && header.dataset.stickyState !== 'idle') {
      offset = Math.max(0, header.getBoundingClientRect().bottom);
    }
    host.style.setProperty('--tb-path-top', `${Math.round(offset)}px`);
    const pinned = marker.getBoundingClientRect().top < offset - 1;
    const interacting = details?.open || host.contains(document.activeElement);
    host.dataset.revealState = !pinned || visible || interacting ? 'visible' : 'hidden';
    host.toggleAttribute('data-pinned', pinned);
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function bindScroll() {
    scrollTarget?.removeEventListener('scroll', schedule);
    scrollTarget = getScrollEventTarget();
    scrollTarget.addEventListener('scroll', schedule, { passive: true });
    lastTop = scrollTop();
    directionTop = lastTop;
    lastDirection = 0;
    schedule();
  }

  const resize = new ResizeObserver(schedule);
  resize.observe(host);
  if (header) resize.observe(header);
  const headerState = new MutationObserver(schedule);
  if (header) headerState.observe(header, { attributes: true, attributeFilter: ['sticky', 'data-sticky-state'] });
  window.addEventListener('resize', schedule, { passive: true, signal });
  window.addEventListener('pageshow', bindScroll, { signal });
  scrollContainerMediaQuery.addEventListener('change', bindScroll, { signal });
  host.addEventListener('focusin', schedule, { signal });
  host.addEventListener('focusout', schedule, { signal });
  details?.addEventListener('toggle', schedule, { signal });
  host.dataset.revealReady = 'true';
  bindScroll();

  window.tbPathRevealCleanup = () => {
    controller.abort();
    scrollTarget?.removeEventListener('scroll', schedule);
    cancelAnimationFrame(frame);
    resize.disconnect();
    headerState.disconnect();
    marker.remove();
    delete host.dataset.revealReady;
    delete host.dataset.revealState;
    host.removeAttribute('data-pinned');
    host.style.removeProperty('--tb-path-top');
  };
}

initializePathReveal();
document.addEventListener('shopify:section:load', initializePathReveal);
